export const drawerWidth = 400;
